import { EnumAPIKey } from "@/constants/app/api";
import {
  EnumEndpoints,
  EnumEndpointsName,
  EnumMethod,
} from "@/constants/app/type";
import { callbackEsimCountries } from "./callbacks/callbackEsimCountries";
// import { callbackEsimPackages } from "./callbacks/callbackEsimPackages"; // legacy live-proxy, replaced by catalog/public/list
import { callbackEsimCatalogPublicList } from "./callbacks/callbackEsimCatalogPublicList";
import { callbackEsimCatalogPublicDetail } from "./callbacks/callbackEsimCatalogPublicDetail";
import { callbackEsimCatalogPublicFilters } from "./callbacks/callbackEsimCatalogPublicFilters";
import { getEsimCatalogPublicFiltersService } from "./callbackServices/getEsimCatalogPublicFiltersService";
import { callbackEsimCollectionPublicList } from "./callbacks/callbackEsimCollectionPublicList";
import { callbackProductContentPublicList } from "./callbacks/callbackProductContentPublicList";

export const esimEndpoints = {
  // Bật lại riêng cho EsimHubTabs (tab Quốc gia/Khu Vực) — form search (SelectCountryCode) vẫn dùng
  // thư viện mã quốc gia cục bộ (i18n-iso-countries) như trước, không đổi.
  [EnumEndpointsName.ESIM_COUNTRIES]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.ESIM_COUNTRIES,
    api: EnumAPIKey.API_BASE,
    caller: callbackEsimCountries,
  },
  // [EnumEndpointsName.ESIM_PACKAGES]: {
  //   method: EnumMethod.POST,
  //   endpoint: EnumEndpoints.ESIM_PACKAGES,
  //   api: EnumAPIKey.API_BASE,
  //   caller: callbackEsimPackages,
  // },
  [EnumEndpointsName.ESIM_CATALOG_PUBLIC_LIST]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.ESIM_CATALOG_PUBLIC_LIST,
    api: EnumAPIKey.API_BASE,
    caller: callbackEsimCatalogPublicList,
  },
  [EnumEndpointsName.ESIM_CATALOG_PUBLIC_DETAIL]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.ESIM_CATALOG_PUBLIC_DETAIL,
    api: EnumAPIKey.API_BASE,
    caller: callbackEsimCatalogPublicDetail,
  },
  [EnumEndpointsName.ESIM_CATALOG_PUBLIC_FILTERS]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.ESIM_CATALOG_PUBLIC_FILTERS,
    api: EnumAPIKey.API_BASE,
    caller: callbackEsimCatalogPublicFilters,
    callerService: getEsimCatalogPublicFiltersService,
  },
  [EnumEndpointsName.ESIM_COLLECTION_PUBLIC_LIST]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.ESIM_COLLECTION_PUBLIC_LIST,
    api: EnumAPIKey.API_BASE,
    caller: callbackEsimCollectionPublicList,
  },
  [EnumEndpointsName.PRODUCT_CONTENT_PUBLIC_LIST]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.PRODUCT_CONTENT_PUBLIC_LIST,
    api: EnumAPIKey.API_BASE,
    caller: callbackProductContentPublicList,
  },
};
